<app-lms-modal-frame [title]="dialogTitle" [pageHeadWidth]="500">
  <div modal-body class="center-screen">
    <form [formGroup]="payslipForm" (submit)="save()" class="form-container" id="payslipForm">
      <table class="table table-auto table-sm shadow-2-strong rounded-1">
        <tbody class="field-4column-label">
          <tr class="border-paydate">
            <td style="width: 35%" class="py-4">
              <strong>Pay Date:</strong>
            </td>
            <td class="py-4 ps-0" style="text-align: left;">
              <div class="input-group input-group-sm" style="min-width: 200px; width: 220px;">
                <input class="form-control rounded-end"
                        readonly
                        aria-readonly="true"
                        style="background: #f8f9fa; cursor: pointer;"
                        [mdbDatepicker]="picker"
                        placeholder="YYYY-MM-DD"
                        formControlName="payslipDate"
                        (click)="picker.toggle()" />
                <mdb-datepicker-toggle [mdbDatepicker]="picker" icon="fas fa-calendar-alt" color="primary"></mdb-datepicker-toggle>
                <mdb-datepicker #picker [confirmDateOnSelect]="true" [format]="'yyyy-mm-dd'" [maxDate]="maxDate"></mdb-datepicker>
              </div>
              <div *ngIf="payslipDate?.invalid && payslipDate?.touched">
                <div *ngIf="payslipDate?.errors?.required">
                  <small class="text-danger">Pay date is required</small>
                </div>
              </div>
            </td>
          </tr>

          <!-- Gross Income Field -->
          <tr>
            <td style="min-width: 35%">
              <strong>Gross Income:</strong>
            </td>
            <td class="income-left">
              <div class="input-group input-group-sm" style="width: 200px;">
                <span class="input-group-text"><strong>R</strong></span>
                <input class="form-control"
                        formControlName="grossIncome"
                        lmsNumbersOnly
                        [allowDecimals]="true"
                        [class.is-invalid]="grossIncome?.invalid && (grossIncome?.touched || submitted)"
                        min="0"
                        [readonly]="clientType === 'SASSA' || clientType === 'Pensioner'">
              </div>
              <div *ngIf="grossIncome?.invalid && (grossIncome?.touched || submitted)">
                <div *ngIf="grossIncome?.errors?.required">
                  <small class="text-danger">Gross income amount is required</small>
                </div>
                <div *ngIf="grossIncome?.errors?.grossIncomeCap">
                  <small class="text-danger">Gross income exceeds the allowed limit</small>
                </div>
              </div>
              <div *ngIf="clientType === 'SASSA' || clientType === 'Pensioner'">
                <small class="text-muted">For {{clientType === 'SASSA' ? 'SASSA' : 'Pensioner'}} clients, gross income equals net income</small>
              </div>
            </td>
          </tr>

          <!-- Nett Income Field -->
          <tr>
            <td style="min-width: 35%">
              <strong>Nett Income:</strong>
            </td>
            <td class="income-left">
              <div class="input-group input-group-sm" style="width: 200px;">
                <span class="input-group-text"><strong>R</strong></span>
                <input class="form-control"
                        formControlName="nettIncome"
                        lmsNumbersOnly
                        [allowDecimals]="true"
                        [class.is-invalid]="nettIncome?.invalid && (nettIncome?.touched || submitted)"
                        min="0">
              </div>
              <div *ngIf="nettIncome?.invalid && (nettIncome?.touched || submitted)">
                <div *ngIf="nettIncome?.errors?.required">
                  <small class="text-danger">Income amount is required</small>
                </div>
                <div *ngIf="nettIncome?.errors?.netExceedsGross">
                  <small class="text-danger">Net income cannot be more than Gross</small>
                </div>
              </div>
            </td>
          </tr>

          <!-- Other Income Field (only for Salaried/Pensioner) -->
          <tr *ngIf="clientType === 'Salaried' || clientType === 'Pensioner'">
            <td style="min-width: 35%">
              <strong>Other Income:</strong>
            </td>
            <td class="income-left">
              <div class="input-group input-group-sm" style="width: 200px;">
                <span class="input-group-text"><strong>R</strong></span>
                <input class="form-control"
                        formControlName="otherIncome"
                        lmsNumbersOnly
                        [allowDecimals]="true"
                        min="0">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="lms-dialog-footer" style="display: flex; justify-content: flex-end; gap: 10px;">
        <button class="btn btn-secondary btn-sm" type="button" (click)="closeDialog()">
      <i class="fas fa-times me-1"></i>Close
      </button>
      <button class="btn btn-primary btn-sm" form="payslipForm" type="submit"  [disabled]="payslipForm.invalid">
        <i class="fas fa-save me-1"></i>Save
      </button>
      </div>
    </form>
  </div>
</app-lms-modal-frame>
